import React from 'react';
import { ModifyValue } from 'containers/ProductDetail/hooks/useProductDetaillHooks';
import ModifyContainer from '../ModifyContainer';
import {
  ProductParamInput,
  ScheduleParam,
} from 'containers/ProductRegist/hooks/types';
import { ScheduleState } from 'types/api';
import styled from 'styled-components';
import Column from 'components/common/Column';
import Text from 'components/common/Text';
import dayjs from 'dayjs';
import { isEmpty } from 'lodash';

const ScheduleCardBox = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 6px;
  border-radius: 4px;

  color: #414b56;
  text-align: center;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: -0.2px;
`;

const StatusBox = styled.div<{ background: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${props => props.background};
`;

interface CalendarContainerIProps {
  isMobile: boolean;
  productParamInput: ProductParamInput;
  modifyValue: ModifyValue;
  setModifyValue: React.Dispatch<React.SetStateAction<ModifyValue>>;
}

const CalendarContainer: React.FC<CalendarContainerIProps> = props => {
  const { isMobile, productParamInput, modifyValue, setModifyValue } = props;

  const renderStatusItem = (item: ScheduleParam): JSX.Element => {
    switch (item.status) {
      case ScheduleState.OPENED: {
        return (
          <ScheduleCardBox>
            <StatusBox background="#0071E9" />
            <span>판매중</span>
          </ScheduleCardBox>
        );
      }
      case ScheduleState.PAUSED: {
        return (
          <ScheduleCardBox>
            <StatusBox background="#FF9200" />
            <span>판매중지</span>
          </ScheduleCardBox>
        );
      }
      case ScheduleState.SOLD_OUT: {
        return (
          <ScheduleCardBox>
            <StatusBox background="#DBDCDF" />
            <span>매진</span>
          </ScheduleCardBox>
        );
      }
      case ScheduleState.CANCELED: {
        return (
          <ScheduleCardBox>
            <StatusBox background="#FF4242" />
            <span>취소</span>
          </ScheduleCardBox>
        );
      }
      case ScheduleState.EDITING: {
        return (
          <ScheduleCardBox>
            <StatusBox background="#414B56" />
            <span>등록중</span>
          </ScheduleCardBox>
        );
      }
    }

    return;
  };

  return (
    <ModifyContainer
      title="일정"
      isSelected={!isMobile && modifyValue.modifyStatus === 'calendar'}
      onClick={() => {
        setModifyValue({ ...modifyValue, modifyStatus: 'calendar' });
      }}
    >
      {isEmpty(productParamInput.frip.schedules) ? (
        <Text
          color="#414B56"
          size="16px"
          style={{ textAlign: 'center', lineHeight: '22px' }}
        >
          등록된 일정이 없습니다. <br />
          일정을 1개 이상 등록해야 상품 수정 및 <br />
          재판매가 가능해요.
        </Text>
      ) : (
        <Column gap="32px">
          {productParamInput.frip.schedules.map((item, idx) => {
            return (
              <Column align="flex-start" gap="6px" key={idx}>
                {renderStatusItem(item)}
                <Text
                  color="#414B56"
                  size="16px"
                  style={{ lineHeight: '24px' }}
                >
                  {dayjs(item.term.startedAt).format('YYYY년 M월 D일 HH:mm')} ~{' '}
                  {dayjs(item.term.startedAt + item.term.duration).format(
                    'YYYY년 M월 D일 HH:mm',
                  )}
                </Text>
                <Column gap="4px" align="flex-start">
                  {item.appliedAllItems ? (
                    <Text color="#70737C" size="14px" weight={400}>
                      • 모든 옵션 적용중
                    </Text>
                  ) : (
                    productParamInput.items.map((items, itemsIdx) => {
                      return (
                        <React.Fragment key={itemsIdx}>
                          {item.itemParamIds.includes(items.paramId) && (
                            <Text color="#70737C" size="14px" weight={400}>
                              • {items.name}
                            </Text>
                          )}
                        </React.Fragment>
                      );
                    })
                  )}
                </Column>
              </Column>
            );
          })}
        </Column>
      )}
    </ModifyContainer>
  );
};

export default CalendarContainer;
